import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import UserTalentContent from './UserTalentContent'
export default class UserTalent extends React.Component {
    
    render() {
        let id = this.props.match.params.id;
       
        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <UserTalentContent profile_id={id} />
                <Footer /> 

            </div>


        )
    }
}
